import { useCallback, useEffect, useState } from "react";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import { Box, CircularProgress } from "@mui/material";
import { getRequest, singoutHandler } from "../../../../api/AxiosAPICall";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { useNavigate } from "react-router-dom";
const ClinicainPricing = ({
  formik,
  sendPrice,
  loader,
  sendCloseSnackbar,
}: {
  formik: any;
  sendPrice: any;
  loader: any;
  sendCloseSnackbar: any;
}) => {
  const [IsCustomePriceSelected, setCustomePriceSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [bookingCharges, setBookingCharges] = useState("");
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  let history = useNavigate();

  const fetchCellmaPreference = async () => {
    await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "cellmaflex_appointment_booking_charges",
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setBookingCharges(response.data);
      }
    });
  };

  const fetchestablishmentProfessionalJson = useCallback(async () => {
    setOpen(true);
    const response = await getRequest(
      "establishmentProfessionals/defaultPrices",
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response?.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response?.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      sendPrice(response?.data?.defaultPrice);
      if (
        response?.data?.defaultPrice?.etpId !== undefined &&
        response?.data?.defaultPrice?.etpId !== null &&
        response?.data?.defaultPrice?.etpId !== ""
      ) {
        formik.setFieldValue("etpId", response.data.defaultPrice.etpId);
      }
      if (
        response.data?.defaultPrice?.etpDefaultPrice !== undefined &&
        response.data?.defaultPrice?.etpDefaultPrice !== null &&
        response.data?.defaultPrice?.etpDefaultPrice !== "" &&
        (response.data?.defaultPrice?.etpDefaultPrice !== 0 ||
          response.data?.defaultPrice?.etpDefaultPrice !== 0.0)
      ) {
        formik.setFieldValue(
          "enterAmount",
          response.data.defaultPrice.etpDefaultPrice
        );
        formik.setFieldValue("price", true);
      } else {
        formik.setFieldValue("price", false);
      }
    }
    setOpen(false);
    sendCloseSnackbar("priceSnackbar");
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    jwtToken && fetchestablishmentProfessionalJson();
    fetchCellmaPreference();
    // eslint-disable-next-line
  }, [loader]);
  return (
    <CommonCard>
      <Typography variant="h6" className={globalClasses.typography}>
        Pricing
      </Typography>
      {open && (
        <Box className={globalClasses.loader}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {!open && (
        <FormControl component="fieldset">
          <RadioGroup row>
            <FormControlLabel
              id="price"
              name="price"
              value="Free"
              control={
                <Radio
                  checked={!IsCustomePriceSelected}
                  className={globalClasses.radioButton}
                />
              }
              label="Free"
              labelPlacement="start"
              onClick={() => {
                setCustomePriceSelected(false);
                formik.setFieldValue("price", false);
              }}
            />
          </RadioGroup>
          {IsCustomePriceSelected && (
            <>
              <input
                type="hidden"
                id="etpId"
                name="etpId"
                value={formik?.values?.etpId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <InputField
                id="enterAmount"
                name="enterAmount"
                type="number"
                disable={true}
                inputvalues={formik.values.enterAmount}
                errormessage={
                  formik.touched.enterAmount &&
                  Boolean(formik.errors.enterAmount)
                }
                message={
                  formik.touched.enterAmount && formik.errors.enterAmount
                }
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={true}
                label="Enter Amount"
              />
              {bookingCharges !== undefined &&
                bookingCharges !== "" &&
                bookingCharges !== null && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#555555",
                      marginLeft: "20px",
                    }}
                  >
                    ${bookingCharges} appointment reservation charges (included
                    in above cost)
                  </Typography>
                )}
            </>
          )}
        </FormControl>
      )}
    </CommonCard>
  );
};

export default ClinicainPricing;
